/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where a delivery stands. Mirrors the database enum company_webhook_delivery_state: `pending` is waiting for its next attempt on the retry schedule; `delivered` means the endpoint accepted it; `exhausted` means every attempt on the schedule failed; `failed` means it stopped without retrying because the webhook was deleted or paused, or the endpoint cannot be reached from this environment; `superseded` means a newer state event for the same shipment replaced it before its next retry, so it was not sent again.
 * @export
 */
export const WebhookDeliveryState = {
    Pending: 'pending',
    Delivered: 'delivered',
    Failed: 'failed',
    Exhausted: 'exhausted',
    Superseded: 'superseded'
} as const;
export type WebhookDeliveryState = typeof WebhookDeliveryState[keyof typeof WebhookDeliveryState];


export function instanceOfWebhookDeliveryState(value: any): boolean {
    for (const key in WebhookDeliveryState) {
        if (Object.prototype.hasOwnProperty.call(WebhookDeliveryState, key)) {
            if (WebhookDeliveryState[key as keyof typeof WebhookDeliveryState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WebhookDeliveryStateFromJSON(json: any): WebhookDeliveryState {
    return WebhookDeliveryStateFromJSONTyped(json, false);
}

export function WebhookDeliveryStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookDeliveryState {
    return json as WebhookDeliveryState;
}

export function WebhookDeliveryStateToJSON(value?: WebhookDeliveryState | null): any {
    return value as any;
}

export function WebhookDeliveryStateToJSONTyped(value: any, ignoreDiscriminator: boolean): WebhookDeliveryState {
    return value as WebhookDeliveryState;
}

